import script from "./UIPagePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./UIPagePanel.vue?vue&type=script&lang=ts&setup=true"

import "./UIPagePanel.vue?vue&type=style&index=0&id=41cccded&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41cccded"]])

export default __exports__